export default __webpack_public_path__ + "static/media/mountain.b19dbf26.png";